import angular = require("angular");
import TPL = require("templates");

export class LoaderDirective {

  scope;
  template;

  constructor() {
    this.template = TPL.commonDirectives.loader;
    this.scope = {
      name: "=name"
    }
  }

  static factory() {
    var tmp = () => new LoaderDirective();
    return tmp;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/common/loader.ts
 **/